module.exports = __webpack_public_path__ + "img/desktop/Menus-betmenu/btn-settings-up@2x.png?1.0.24";


//////////////////
// WEBPACK FOOTER
// ./out/img/desktop/Menus-betmenu/btn-settings-up@2x.png
// module id = 576
// module chunks = 0